export default __webpack_public_path__ + "images/O8.27b6cba.png";